"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Webcam2Alternate: ['webcam-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4,8.722A8,8,0,1,0,17.17,2.628a.249.249,0,0,0-.339.014A6.806,6.806,0,0,1,12,4.662a6.806,6.806,0,0,1-4.831-2.02.249.249,0,0,0-.339-.014A7.982,7.982,0,0,0,4,8.722Zm8-3a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,12,5.723Z', 'M12,3.162a5.3,5.3,0,0,0,3.431-1.269.25.25,0,0,0-.057-.418q-.226-.1-.461-.2a10.755,10.755,0,0,0-5.826,0q-.234.093-.461.2a.25.25,0,0,0-.057.418A5.3,5.3,0,0,0,12,3.162Z', 'M16.535,17.3A.506.506,0,0,0,16,17.227a9.4,9.4,0,0,1-8,0,.5.5,0,0,0-.536.072,7.021,7.021,0,0,0-2.35,4.052,1.5,1.5,0,0,0,1.477,1.772H17.408a1.5,1.5,0,0,0,1.477-1.772A7.023,7.023,0,0,0,16.535,17.3Z']],
  Webcam1: ['webcam-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,8.5A5.506,5.506,0,0,0,18.5,3H5.5a5.5,5.5,0,0,0,0,11h4.75a.25.25,0,0,1,.25.25v2.654a.251.251,0,0,1-.208.246,9.884,9.884,0,0,0-3.783,1.487,1.389,1.389,0,0,0-.5,1.316A1.054,1.054,0,0,0,6.958,21H17.042a1.054,1.054,0,0,0,.946-1.047,1.387,1.387,0,0,0-.5-1.315,9.892,9.892,0,0,0-3.784-1.489A.249.249,0,0,1,13.5,16.9V14.251a.25.25,0,0,1,.25-.25H18.5A5.506,5.506,0,0,0,24,8.5Zm-12,3a3,3,0,1,1,3-3A3,3,0,0,1,12,11.5Z']],
  Webcam2: ['webcam-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.500 8.551 A2.500 2.500 0 1 0 14.500 8.551 A2.500 2.500 0 1 0 9.500 8.551 Z', 'M16.158,18.07A.508.508,0,0,0,15.622,18a8.532,8.532,0,0,1-7.244,0,.5.5,0,0,0-.536.072,6.423,6.423,0,0,0-2.154,3.716,1.409,1.409,0,0,0,1.388,1.665h9.848a1.411,1.411,0,0,0,1.388-1.665A6.423,6.423,0,0,0,16.158,18.07Z', 'M12,17.55a8.5,8.5,0,1,0-8.5-8.5A8.51,8.51,0,0,0,12,17.55Zm4.5-8.5a4.5,4.5,0,1,1-9,0V4.479A.248.248,0,0,1,7.58,4.3a6.468,6.468,0,0,1,8.84,0,.248.248,0,0,1,.08.183Z']]
};
exports["default"] = _default;